import BreadcrumbNav from '../common/BreadcrumbNav/index.js';
import {HomeOutlined} from '@ant-design/icons';
import {getLocaleContent} from '@helper/locale-content.js';
import {useRouter} from 'next/router';

function AboutUsNav() {
    const {locale} = useRouter();
    return (
        <div>
            <BreadcrumbNav
                items={[
                    {label: '', href: '/', icon: <HomeOutlined />},
                    {
                        label: getLocaleContent(locale, 'page.about-us.nav_title'),
                        href: '/gioi-thieu-tnh',
                        color: '#006940',
                    },
                ]}
            />
        </div>
    );
}

export default AboutUsNav;
